export {
    default as ViewBase,
    IViewBaseProps,
} from './base';
